




import {Component, Vue} from 'vue-property-decorator'
import DataGrid from '@/components/DataGrid.vue'
import {getJobsAllocatedInAMonthGrid} from '@/data/sources/jobsAllocatedInAMonth.ts'
import {getCarterUtilisationPercentageBreakdown} from '@/data/sources/carterUtilization.ts'

@Component({
  components: {
    DataGrid,
  },
})
export default class SkanskaPPMDrillDown extends Vue {
  public tableData: object[] = []
  public fields = [
    {name: 'Task_Id', title: 'PPM occ id', dataType: 'Number', sort: 1},
    {name: 'Reported_Date_Time', title: 'Reported date time', dataType: 'Date', sort: 1},
    {name: 'Reporter_Name', title: 'Asset id', dataType: 'number', sort: 1},
    {name: 'Problem_Short_Desc', title: 'Short description', dataType: 'Text', sort: 1},
    {name: 'Site_Desc', title: 'Site', dataType: 'Text', sort: 1},
    {name: 'Building_Desc', title: 'Building', dataType: 'Text', sort: 1},
    {name: 'Status', title: 'Status', dataType: 'Text', sort: 1},
    {name: 'Complete_Date', title: 'Completed', dataType: 'Date', sort: 1},
  ]
  private currentMonth: number = new Date().getMonth() + 1
  private currentYear: number = new Date().getFullYear()

  public getData() {
    return getJobsAllocatedInAMonthGrid(1, this.currentMonth, this.currentYear, 1, 0, 29, 0, 1)
  }
}
